export const MS_IN_SEC = 1000;
export const SEC_IN_MIN = 60;
export const MIN_IN_HOUR = 60;
export const HOURS_IN_DAY = 24;

export const MS_IN_DAY = MS_IN_SEC * SEC_IN_MIN * MIN_IN_HOUR * HOURS_IN_DAY;

export const ISO_DATE_START_INDEX = 0;
export const ISO_DATE_END_INDEX = 10;